import { css } from 'styled-components';
import { type PropsWithTheme } from '../../styled';

export const tableMixin = ({
  theme: {
    column: { cornerRadius }
  }
}: PropsWithTheme) => css`
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: ${cornerRadius}px;

  & > div {
    position: static;
  }
`;
